import React, { FC } from 'react';
import {
  Box,
  Container,
  Grid,
  Skeleton,
  Stack,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/OffRoadToursLandingViewV2/components/OffRoadUTVPromoSection/OffRoadUTVPromoSection.styles';

const OffRoadUTVPromoSectionSkeleton: FC = () => {
  const renderTitleBlockSkeleton = () => (
    <Box>
      <Skeleton
        variant="text"
        width="72%"
        height={38}
        sx={{ maxWidth: 360, mb: 0.25 }}
      />
      <Skeleton
        variant="text"
        width="92%"
        height={38}
        sx={{ maxWidth: 420, mb: 0.25 }}
      />
      <Skeleton
        variant="text"
        width="68%"
        height={38}
        sx={{ mb: 2, maxWidth: 320 }}
      />
      <Box className="ORUTVRideDuration">
        <Skeleton variant="rounded" width={32} height={32} />
        <Skeleton variant="text" width={100} height={22} />
      </Box>
    </Box>
  );

  return (
    <StyledBox>
      <Box className="ORUTVBGPattern">
        <Skeleton animation="wave" height="100%" variant="rectangular" width="100%" />
      </Box>
      <Container className="ORUTVPromoContainer" maxWidth="xl">
        <Grid
          alignItems="center"
          container
          spacing={{ xs: 4, sm: 4, lg: 8 }}>
          <Grid item className="showTABLET" xs={12}>
            {renderTitleBlockSkeleton()}
          </Grid>
          <Grid item lg={6} md={12} sm={12}>
            <Stack className="ORUTVPromoContentStack">
              <Box className="showDESKTOP">{renderTitleBlockSkeleton()}</Box>
              <Box sx={{ width: '100%' }}>
                <Skeleton variant="text" width="100%" height={20} />
                <Skeleton variant="text" width="95%" height={20} />
                <Skeleton variant="text" width="70%" height={20} />
              </Box>
              <Box className="ORUTVPromoDatesBlock">
                <Box className="ORUTVPromoDatesInner">
                  <Box className="ORUTVPromoDatesRow">
                    <Skeleton height={24} variant="rounded" width={24} />
                    <Skeleton height={24} sx={{ flex: 1 }} variant="text" />
                  </Box>
                  <Box className="ORUTVPromoDatesRow">
                    <Skeleton height={24} variant="rounded" width={24} />
                    <Box
                      className="ORUTVPromoDateChips"
                      sx={{ flex: 1, flexWrap: 'wrap' }}>
                      {[1, 2, 3, 4, 5].map((i) => (
                        <Skeleton
                          key={i}
                          height={34}
                          sx={{ borderRadius: 0.5 }}
                          variant="rounded"
                          width={88}
                        />
                      ))}
                    </Box>
                  </Box>
                </Box>
                <Box className="ORUTVPromoDatesRow">
                  <Skeleton height={24} variant="rounded" width={24} />
                  <Skeleton height={22} sx={{ flex: 1 }} variant="text" />
                </Box>
              </Box>
              <Skeleton
                animation="wave"
                className="ORUTVPromoBookBtn"
                height={48}
                sx={{ width: { xs: '100%', md: 250 } }}
                variant="rounded"
              />
            </Stack>
          </Grid>
          <Grid item lg={6} md={12} sm={12}>
            <Box className="ORUTVPromoImage">
              <Skeleton
                animation="wave"
                height="100%"
                sx={{ borderRadius: 1, minHeight: 291 }}
                variant="rectangular"
                width="100%"
              />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </StyledBox>
  );
};

export { OffRoadUTVPromoSectionSkeleton };
